/* eslint-disable jsdoc/require-example */
import {isMobile} from 'Utils/deviceUtils';
import {removeClassesFromElement} from 'Utils/elementUtils';

const MOBILEMAXLINKSVISIBLES = 5;
const COLLAPSEDCLASSNAME = 'link-item_hidden';
const ICONARROWUPCLASSNAME = 'rotate-180';
const ALIGNMENTVERTICAL = 'link-list_alignmentType_vertical';

export default class LinkList {
    constructor(domElement) {
        if(domElement.getAttribute('data-linklist-initialized') === 'true') {
            throw new Error('Module already initialized');
        }
        this.domElement = domElement;
        this.domElement.dataset.linklistInitialized = 'true';
        this.seeMoreButton = this.domElement.querySelector('[data-see-more-btn]');
        this.domLinks = [
            ...this.domElement.querySelectorAll('.link-item')
        ];
        this.typeAlignmentVertical = domElement.getAttribute('data-alignmenttype') === ALIGNMENTVERTICAL;
        this.iconArrow = this.seeMoreButton.querySelector('.axa-icons');
        this.init();
        this.initListeners();
    }

    init() {
        this.displaySeeMoreButton();
        this.refreshLinks();
    }

    initListeners() {
        this.seeMoreButton.addEventListener('click', this.handleSeeMoreButtonClick.bind(this));
    }

    refreshLinks() {
        if(this.isTypeAlignmentVerticalOrMobile() && this.isCollapsed()) {
            this.domLinks.slice(MOBILEMAXLINKSVISIBLES).forEach(domLink => {
                domLink.classList.add(COLLAPSEDCLASSNAME);
            });
        } else {
            this.displayAll();
        }
    }

    isTypeAlignmentVerticalOrMobile() {
        return isMobile() || this.typeAlignmentVertical;
    }

    displaySeeMoreButton() {
        if(!this.isTypeAlignmentVerticalOrMobile() || this.domLinks.length <= MOBILEMAXLINKSVISIBLES) {
            this.seeMoreButton.classList.add(COLLAPSEDCLASSNAME);
        }
    }

    handleSeeMoreButtonClick() {
        this.reverseSeeMoreButton();
        this.refreshLinks();
    }

    displayAll() {
        this.domLinks.forEach(domLink => {
            removeClassesFromElement(domLink, COLLAPSEDCLASSNAME);
        });
    }

    isCollapsed() {
        return !this.iconArrow.classList.contains(ICONARROWUPCLASSNAME);
    }

    reverseSeeMoreButton() {
        if(this.isCollapsed()) {
            this.iconArrow.classList.add(ICONARROWUPCLASSNAME);
        } else {
            removeClassesFromElement(this.iconArrow, ICONARROWUPCLASSNAME);
        }
    }
}
